import caseActiveIcon from '../../assets/icons/blue/case_template_blue.svg';
import caseIcon from '../../assets/icons/grey/case_template_grey.svg';
import caseTemplateActiveIcon from '../../assets/icons/blue/case_template_icon_blue.svg';
import caseTemplateIcon from '../../assets/icons/grey/case_template_icon_grey.svg';
import listIcon from '../../assets/icons/grey/list_grey.svg';
import listActiveIcon from '../../assets/icons/blue/list_blue.svg';
import reportsIcon from '../../assets/icons/reports.png';

export default [
  {
    name: 'Reports',
    icon: reportsIcon,
    items: [
      {
        name: 'templates',
        titleKey: 'templates',
        icon: caseTemplateIcon,
        activeIcon: caseTemplateActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/reports/templates',
        roles: '*',
      },
      {
        name: 'cases',
        titleKey: 'cases',
        icon: caseIcon,
        activeIcon: caseActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/reports/cases',
        roles: '*',
      },
      {
        name: 'case-lists',
        titleKey: 'Case lists',
        icon: listIcon,
        activeIcon: listActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/reports/case-lists',
        roles: '*',
      },
    ],
  },
];
